import * as api from '../../services/invoiceVerify'

export const FETCH_INVOICEVERIFYS= 'FETCH_INVOICEVERIFYS';



export const fetchInvoiceverifys = (params, pagination, sort, extra) => {

    return {
        type: FETCH_INVOICEVERIFYS,
        payload: {
            promise: api.findInvoiceverifys(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/invoiceVerify.js